import Vue from 'vue'

// defino variables y funciones globales
export default Vue.mixin({
    data: function () {
        return {
          pagination:{
            page:1,
            length:25
          },
        }
    },
    methods: {
        getValidUrlParams(){
            // parseo las variables de url y devuelvo un objecto con los valres validos
            var items = this.$route.query;

            // si tiene paginacion se la pongo en
            if( items.page ){
                this.pagination.page = items.page
                delete items.page
            }
            var result = {}
            Object.keys(items).forEach(key => {
              var item = items[key]
              
              if(Array.isArray(item)){ // si es un array como pro ejemplo period period, limpio los valores vacioss
                item = item.filter(Boolean);
              }
              if (item != "" && item !=null && item.length > 0){
                result[key] = item
              }
            })
            
            return result
        },
        cleanFilters(){
            var items = this.filters;
            var result = {}
            Object.keys(items).forEach(key => {
              const item = items[key]
              if (item != ""){
                result[key] = item
              }
            })
            return result
        },
        pageChange (page) {
            // cambio pagina
            let params = this.getValidUrlParams()
            params.page = page+1;
            this.$router.replace({ query: params  } );
        },
        updateFilters(){
            // console.log('update Filters', event)
            // console.log('update Filters', this.filters)
            let params = this.cleanFilters()
            delete this.filters.page
            this.$router.replace({ query: params  } );
            // this.pagination.page = 1;
			// if( this.filters.office<=0 ){ delete this.filters.office;	}
			// if( this.filters.type<=0 ){ delete this.filters.type;	}
			// if( this.filters.search=='' ){ delete this.filters.search;	}
			// this.$router.push({ name: 'Contracts', query: this.filters  } );
		},
    }
})
